import { render, staticRenderFns } from "./xtrain.vue?vue&type=template&id=537d6807&scoped=true&"
import script from "./xtrain.vue?vue&type=script&lang=js&"
export * from "./xtrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d6807",
  null
  
)

export default component.exports